import React from 'react';
import { Chip } from '@mui/material';

interface SharedMessageBadgeProps {
  ownerCompanyName: string;
}

export const SharedMessageBadge: React.FC<SharedMessageBadgeProps> = ({
  ownerCompanyName,
}) => {
  return (
    <Chip
      label={`Shared from ${ownerCompanyName}`}
      color="info"
      size="small"
    />
  );
};
